import React from "react";
import "./Menu.css";

import menuImg from "../images/menu.jpg";   // photo of menu
import shopImg from "../images/shop.jpg";   // photo of shop
import cakeImg from "../images/cake1.jpg";
import pastryImg from "../images/cake6.jpg";
import cupcakeImg from "../images/cake7.jpg";

const Menu = () => {
  return (
    <section className="menu-page">

      {/* HERO */}
      <div className="menu-hero">
        <div className="menu-hero-text">
          <h1>Our Menu</h1>
          <p>
            Premium handcrafted cakes and desserts, made fresh every day
            using the finest ingredients.
          </p>
        </div>

        <div className="menu-hero-images">
          <img src={menuImg} alt="Menu" />
          <img src={shopImg} alt="Shop" />
        </div>
      </div>

      {/* CATEGORIES */}
      <div className="menu-categories">

        <div className="menu-card">
          <img src={cakeImg} alt="Cakes" />
          <h3>Cakes</h3>
          <p>Chocolate · Red Velvet · Black Forest · Custom Cakes</p>
          <span>Egg / Eggless · 0.5kg – 5kg</span>
        </div>

        <div className="menu-card">
          <img src={pastryImg} alt="Pastries" />
          <h3>Pastries</h3>
          <p>Chocolate · Strawberry · Pineapple · Blueberry</p>
          <span>Fresh cream · Daily baked</span>
        </div>

        <div className="menu-card">
          <img src={cupcakeImg} alt="Cupcakes" />
          <h3>Cupcakes</h3>
          <p>Vanilla · Chocolate · Red Velvet</p>
          <span>Perfect for gifting</span>
        </div>

      </div>

      {/* CTA */}
      <div className="menu-cta">
        <p>Custom designs available for all occasions</p>
        <a
          href="https://wa.me/08827953485"
          target="_blank"
          rel="noopener noreferrer"
        >
          Order on WhatsApp
        </a>
      </div>

    </section>
  );
};

export default Menu;
